module.exports = __webpack_public_path__ + "static/media/more-vertical.1b170162.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/more-vertical.svg
// module id = 1142
// module chunks = 1